import { createTheme } from "@mui/material";
import defaultTheme from "tailwindcss/defaultTheme";

// theme extracted from tailwind.config for reusability
export const theme = {
  extend: {
    screens: {
      sm: "380px",
      md: "768px",
      lg: "976px",
      xl: "1440px",
      max: "976px",
      min: "380px",
    },
    minWidth: {
      "86": "22rem",
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      white: "#ffffff",
      black: "#000000",

      "ldir-blue-900": "#006178",
      "ldir-blue-800": "#007B97",
      "ldir-blue-700": "#009EC1",
      "ldir-blue-600": "#00AFD7",
      "ldir-blue-500": "#CCEFF7",
      "ldir-blue-400": "#E5EEEE",
      "ldir-blue-300": "#00617819",
      "ldir-blue-200": "#D9E3E64C",
      "ldir-blue-100": "#E3EDF0",
      "ldir-blue-050": "#E3EDF04C",
      "ldir-blue-pale": "#B2CBD1",
      "ldir-blue-paler": "#E5EFF1",

      "ldir-black": "#202020",
      "ldir-gray-900": "#58595B",
      "ldir-gray-800": "#929391",
      "ldir-gray-700": "#D9D9D9",
      "ldir-gray-600": "#F5F5F5",

      "ldir-brown-900": "#37261D",
      "ldir-brown-800": "#4E3629",
      "ldir-brown-700": "#A69A94",
      "ldir-brown-600": "#37261D66",
      "ldir-brown-500": "#DCD7D4",
      "ldir-brown-400": "#EDEBEA",
      "ldir-brown-300": "#F9F9F9",
      "ldir-brown-200": "#F9F9F9E5",

      "ldir-green-900": "#4D907D",
      "ldir-green-800": "#B6E6D8",
      "ldir-green-700": "#D4F0E8",
      "ldir-green-600": "#E2F5F07F",

      "ldir-red-900": "#931B22",
      "ldir-red-800": "#D22630",
      "ldir-red-700": "#F6D4D6",
      "ldir-red-600": "#FBE9EA7F",

      "ldir-orange-900": "#DE7900",
      "ldir-orange-800": "#FF9800",
      "ldir-orange-700": "#FFE0B3",
      "ldir-orange-600": "#FFEACC7F",
      "ldir-orange-500": "#FFF5E67F",
    },
    fontFamily: {
      sans: ["Arial", ...defaultTheme.fontFamily.sans],
      serif: ["Georgia", ...defaultTheme.fontFamily.serif],
    },
    backgroundImage: {
      banner: "url('/src/assets/img/backgroundBanner.svg')",
      banner2: "url('/src/assets/img/backgroundBanner2.svg')",
      banner3: "url('/src/assets/img/backgroundBanner3.svg')",
    },
  },
};
export const muiOverrides = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: theme.extend.colors["ldir-blue-900"],
    },
    secondary: {
      main: theme.extend.colors["ldir-blue-100"],
    },
  },
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          "& .MuiCircularProgress-svg": {
            height: "auto",
            width: "auto",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          backgroundColor: theme.extend.colors["ldir-blue-800"],
          color: "#F9F9F999",
          position: "relative",
          borderBottom: "none",
          "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            height: "4px", // height of the shadow
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.25), #F9F9F9)",
            pointerEvents: "none",
          },

          "&.Mui-selected": {
            backgroundColor: theme.extend.colors["ldir-blue-800"],
            borderBottom: "8px solid",
            borderBottomColor: theme.extend.colors["ldir-blue-600"],
            color: theme.extend.colors["ldir-brown-300"],
            "&.doubleTab": {
              "&::after": {
                display: "none", // remove shadow for selected tab
              },
            },
            zIndex: 1,
            opacity: 1,
            "& .icon": {
              stroke: "white 1px",
              opacity: 1,
            },
            "& .count": {
              backgroundColor: "white",
              opacity: 1,
            },
          },
          "& .icon": {
            stroke: "1px #F9F9F9",
            opacity: 0.6,
          },
          "& .count": {
            backgroundColor: "white",
            opacity: 0.6,
          },
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          fontSize: "1.95rem",
        },
        label: {
          marginTop: "7px",
          fontSize: "0.95rem",
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          padding: 1,
          width: 65,
          "& .MuiSwitch-track": {
            backgroundColor: "#98CAD5",
            borderRadius: 100,
            opacity: 1,
          },
          "& .Mui-checked+": {
            "& .MuiSwitch-track": {
              opacity: "1 !important",
              backgroundColor: "#007B97",
            },
          },
          "& .MuiSwitch-thumb": {
            backgroundColor: "white",
            boxShadow: "none",
            width: 18,
            height: 18,
            margin: 2,
          },
          "& .MuiSwitch-switchBase": {
            "&.Mui-checked": {
              transform: "translateX(26px)",
            },
          },
        },
      },
    },
  },
});

export const materialTailwindThemeOverrides = {
  input: {
    styles: {
      base: {
        container: {
          position: "relative",
          width: "w-full",
          minWidth: "min-w-10",
        },
        input: {
          width: "w-full",
        },
      },
      variants: {
        standard: {
          base: {
            input: {
              borderWidth: "0",
            },
          },
        },
      },
    },
  },
};
